module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-red-45e2b302152080d22e01bf7e95d7b9d6.svg";